import { render, staticRenderFns } from "./EditTenantContactDialog.vue?vue&type=template&id=1c060773"
import script from "./EditTenantContactDialog.vue?vue&type=script&lang=js"
export * from "./EditTenantContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports